import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-98a15180")

_pushScopeId("data-v-98a15180")
const _hoisted_1 = { class: "writing-board-tool" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_WritingBoard = _resolveComponent("WritingBoard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_WritingBoard, {
        ref: "writingBoardRef",
        color: _ctx.writingBoardColor,
        model: _ctx.writingBoardModel
      }, null, 8, ["color", "model"])
    ]))
  ]))
})